


<template>
    <div class="page-sidebar" id="nav-page-sidebar">
        <Loading v-model:active="isLoading">
        </Loading>

        <div class="logo-wrap resp-logo">

            <a href="javascript:;" @click="goToHomeRoute" v-if="companyId=='DB69182F-9412-4139-BCF1-E7656AB63099'">
                <img :src="logoSecondary" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
            </a>
            <a href="javascript:;" @click="goToHomeRoute" v-else>
                <img :src="logoPrimary" class="img-fluid for-light logoSecondary" alt="" id="logoimg">
            </a>


            <div class="back-btn d-lg-none d-inline-block" @click="toggleSlider">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
            </div>
        </div>
        <div class="main-sidebar">

            <div id="mainsidebar">
                <ul class="sidebar-menu custom-scrollbar">
                    <li>
                        <div class="user-profile">
                            <div class="media">
                                <div class="change-pic">
                                    <router-link v-if="userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12' " to="/userProfile" href="Javascript:;">
                                        <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                        <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                    </router-link>
                                    <router-link v-else to="/userProfile">
                                        <img :src="imageLink" class="img-fluid" alt="" v-if="$filters.IsNull(imageLink)!=null">
                                        <span class="avatarttext" v-if="$filters.IsNull(imageLink)==null">{{$filters.FirstAndLastNameAlpha(name.firstName,name.lastName)}}</span>
                                    </router-link>
                                </div>
                                <div class="media-body">
                                    <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-if="(companyId != '526C12D1-97B1-4F5A-A454-147AAC613505' && companyId != '526c12d1-97b1-4f5a-a454-147aac613505')&&(userType == 'usertype01' || userType == 'usertype02' || userType == 'usertype04' ||userType == 'usertype06' ||userType == 'usertype11' ||userType == 'usertype12')"><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>
                                    <router-link to="/userProfile" @click="CheckRoute" href="javascript:;" v-else><h6>{{name.firstName}} {{name.lastName}}</h6></router-link>

                                    <h6 v-if="companyId == '526C12D1-97B1-4F5A-A454-147AAC613505' || companyId == '526c12d1-97b1-4f5a-a454-147aac613505'">{{name.firstName}} {{name.lastName}}</h6>
                                    <span v-if="headerData!=null && headerData!='' && headerData.userType!='Buyer'  && headerData.userType!='Seller' && headerData.userType!='Ambassador' && headerData.userType!='Realtor'">
                                        {{headerData.userType}}
                                    </span>
                                    <span v-if="(headerData!=null && headerData!='' && (headerData.userType=='Buyer'  || headerData.userType=='Ambassador' || headerData.userType=='Seller' || headerData.userType=='Realtor'))">
                                        {{$t(`sidebar.Member`)}}
                                    </span>
                                </div>
                            </div>
                        </div>


                    </li>
                    <li :class="['sidebar-link', 'only-link', rootGroupParentLiClass(item)]" v-for="(item,index) in moduleList" v-bind:key="item.moduleId">

                        <a href="javascript:void(0)" class="sidebar-link single_click only-link"
                           v-if="!item.subModules && item.moduleCode!='999999999' && item.categoryModules==null"
                           @click="redirectToPath(item.moduleRoute)" :title="[$t(`sidebar.${item.moduleName}`)]"
                           :class="[{'active':checkParentRoute(item.moduleCode)},'menuElelment_'+ item.moduleId]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <vue-feather v-if="shouldShowSidebarMenuIcon(item, { level: 'root' })" :type="item.moduleCssClass"></vue-feather>
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>



                        <p class="sidebar-link single_click only-link sidebar-group-label"
                           v-if="!item.subModules && item.moduleCode!='999999999' && item.categoryModules!=null"
                           :title="[$t(`sidebar.${item.moduleName}`)]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </p>
                        <a href=" https://crm.fraxioned.com/" target="_blank" class="sidebar-link single_click only-link"
                           v-if="!item.subModules && item.moduleCode=='999999999' && item.categoryModules!=null"
                           :title="[$t(`sidebar.${item.moduleName}`)]"
                           :class="[{'active':checkParentRoute(item.moduleCode)},'menuElelment_'+ item.moduleId]"
                           :active="index === activeIndex" :attribute-id="[item.moduleId]">
                            <vue-feather :type="item.moduleCssClass"></vue-feather>
                            <span>{{$t(`sidebar.${item.moduleName}`)}} </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>
                        <ul>
                            <li v-for="(mainCatgory,activeIndex1) in item.categoryModules">
                                <a href="javascript:void(0)" class="sidebar-link single_click only-link"
                                   v-if="!mainCatgory.subModules && mainCatgory.moduleCode!='999999999'"
                                   @click="redirectToPath(mainCatgory.moduleRoute)" :title="[$t(`sidebar.${mainCatgory.moduleName}`)]"
                                   :active="index === activeIndex1" :attribute-id="[mainCatgory.moduleId]">

                                    <vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>
                                    <span>{{$t(`sidebar.${mainCatgory.moduleName}`)}} </span>
                                    <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                                </a>


                                <a href="javascript:void(0)" class="sidebar-link"
                                   v-if="mainCatgory.subModules  && mainCatgory.moduleCode!='999999999'"
                                   v-bind:data-bs-target="['#'+ mainCatgory.moduleRoute ]"
                                   v-bind:attribute-id="[mainCatgory.moduleId]"
                                   data-bs-toggle="collapse" :title="[$t(`sidebar.${mainCatgory.moduleName}`)]"
                                   :class="[{'active':checkParentRoute(item.moduleCode)}, 'sidebar-link multiple_click sub_moduleRoute addhighlited_' + mainCatgory.moduleId]">
                                    <vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>

                                    <span>{{$t(`sidebar.${mainCatgory.moduleName}`)}} </span>
                                    <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                                </a>
                                <ul :id="[mainCatgory.moduleRoute]"
                                    :class="[{'show':checkParentRoute(item.moduleCode)},'nav-submenu collapse menu-content menuElelment_'+ mainCatgory.moduleId]" data-bs-parent="#mainsidebar" v-if="mainCatgory.subModules">

                                    <li v-for="childItem in mainCatgory.subModules" v-bind:key="childItem.moduleId">

                                        <a v-if="!childItem.subModules && !childItem.isForRightMenu &&  childItem.moduleCode!=1024 && childItem.moduleCode!=9011012" href="Javascript:;" :class="{'active':checkCurrentRoute(childItem)}"
                                           :title="[$t(`sidebar.${childItem.moduleName}`)]" @click="redirectToPath(childItem.moduleRoute)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                                            <span>{{$t(`sidebar.${childItem.moduleName.replace("'",'')}`)}} </span>
                                        </a>

                                        <a v-if="!childItem.subModules && !childItem.isForRightMenu && ( childItem.moduleCode==1024 || childItem.moduleCode==9011012)" href="Javascript:;" :class="{'active':checkCurrentRoute(childItem)}"
                                           :title="childItem.moduleName" @click="redirectToPath(childItem.moduleRoute)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
                                            <span>{{childItem.moduleName}} </span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li class="sidebar-link only-link">
                        <a href="javascript:void(0)" @click="logout()" class="sidebar-link single_click only-link">

                            <!--<vue-feather :type="mainCatgory.moduleCssClass"></vue-feather>-->
                            <i class="fa fa-power-off" aria-hidden="true"></i>
                            <span>Logout </span>
                            <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>


    

</template>

<loading v-model:active="isLoading" />
<script>
    import userAuthService from '@/service/userAuthService';
    import {
        applyCoOwnerMenuPolicyToSidebarTree,
        CO_OWNER_MENU_UPDATED_EVENT,
        getManageOwnedAssetsPostLoginRoute,
        shouldRestrictCoOwnerMenuSync
    } from '@/helpers/coOwnerSidebarMenu';
    import { initShellLayoutWhenReady, syncSidebarShellState } from '@/helpers/shellLayout';
    import {
        rootGroupParentLiClass,
        shouldShowSidebarMenuIcon
    } from '@/helpers/assetManagerSidebarMenu';
    import {
        COMPANY_LOGOS_UPDATED_EVENT,
        applyLogoImgDomSrc,
        resolveSidebarLogoDisplaySrc,
        resolveSidebarLogoPrimary
    } from '@/helpers/companyLogos';
    import {
        isManageAssetsListRoute,
        resolveManageAssetsNavigationPath
    } from '@/helpers/manageAssetsNavigation';
    import SimpleDialog from "@/views/shared/SimpleDialog.vue";

    import { createConfirmDialog } from "vuejs-confirm-dialog";
    import UserService from '@/service/user.service';
    //mport Loading from 'vue-loading-overlay';

    export default {
        name: 'HelloWorld',
        props: {
            msg: String

        }, components: {
            
        },
        data() {

            let name = {
                firstName: '',
                lastName: ''
            }

            return {
                form: {
                    username: "",
                    password: "",
                    isLoading: false
                },
                companyId: localStorage.getItem("companyId"),
                showError: false, headerData: null, imageLink: null, name, logoPrimary: null, logoSecondary: null,
                isLoading: false, moduleList: [], activeIndex: 0,
                logoPrimary: localStorage.getItem('primaryLogo'),
                logoSecondary: localStorage.getItem('secondaryLogo'),

                Svg: ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>'
            };
        },
        created() {
            this.$t
            debugger;

            this.refreshLogosFromStorage();

            
            if (window.location.pathname == '/account/setpassword') {
                //window.localStorage.clear();
                //window.location.reload();

            }
            this.GetHeaderData();
            var data = JSON.parse(localStorage.getItem('userinfo')).data;
            this.name = data;
            this.GetModuleList();
        },
        mounted() {
            this._onCoOwnerMenuUpdated = () => {
                this.GetModuleList();
            };
            this._onCompanyLogosUpdated = () => {
                this.refreshLogosFromStorage();
            };
            window.addEventListener(CO_OWNER_MENU_UPDATED_EVENT, this._onCoOwnerMenuUpdated);
            window.addEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
            this.$nextTick(() => {
                initShellLayoutWhenReady();
            });
        },
        unmounted() {
            if (this._onCoOwnerMenuUpdated) {
                window.removeEventListener(CO_OWNER_MENU_UPDATED_EVENT, this._onCoOwnerMenuUpdated);
            }
            if (this._onCompanyLogosUpdated) {
                window.removeEventListener(COMPANY_LOGOS_UPDATED_EVENT, this._onCompanyLogosUpdated);
            }
        },
        methods: {
            rootGroupParentLiClass,
            shouldShowSidebarMenuIcon,
            refreshLogosFromStorage() {
                this.logoSecondary = localStorage.getItem('secondaryLogo');
                this.logoPrimary = resolveSidebarLogoPrimary();
                applyLogoImgDomSrc(resolveSidebarLogoDisplaySrc(this.companyId));
            },
            goToHomeRoute() {
                if (this.userType == 'usertype21') {
                    if (localStorage.getItem('isAssetAssigned') == false || localStorage.getItem('isAssetAssigned') == 'false') {
                        this.$router.push('/manageassets');
                    } else {
                        this.$router.push('/dashboard');
                    }
                } else {
                    const path = shouldRestrictCoOwnerMenuSync()
                        ? getManageOwnedAssetsPostLoginRoute()
                        : '/dashboard';
                    this.$router.push(path);
                }
            },
            async logout() {
                try {
                    /*const IPAddress = await UserService.GetIPAddress();*/
                    const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                        question: `${this.$t('ConfirmMessage.LogoutConfirm')}`,
                        header: `${this.$t('ConfirmMessage.Logout')}`,
                        cancel: `${this.$t('ConfirmMessage.Cancel')}`,
                        confirm: `${this.$t('ConfirmMessage.Logout')}`,
                    });

                    onConfirm(() => {
                        this.isLoading = true;
                        UserService.LogoutHistory(localStorage.getItem('userId'), localStorage.getItem("usedcurrentIP")).then(res => {
                        })
                        UserService.Logout(localStorage.getItem('userId')).then(res => {
                        })
                        if (document.getElementById('sidebar') != null) {
                            document.getElementById('sidebar').setAttribute("class", "sidebar js-sidebar collapsed");
                            if (document.getElementById('main_full') != null) {
                                document.getElementById('main_full').setAttribute("class", "main full-section-cc");
                            }
                        }

                        setTimeout(() => {
                            let userType = JSON.parse(localStorage.getItem('userinfo')).data.userType;
                            let companyUrl = localStorage.getItem('companyUrl')
                            let backOrigin = localStorage.getItem('backOrigin')
                            var sessionData = localStorage.getItem('adminTheme');
                            localStorage.clear();
                            localStorage.setItem("adminTheme", sessionData);
                            if ((userType == ('usertype07') || userType == ('usertype05') || userType == ('usertype10') || userType == ('usertype03')
                                || userType == ('usertype09') || userType == ('usertype11') || userType == ('usertype12'))
                                && this.$filters.IsNull(companyUrl, true, null) != null) {
                                if (backOrigin != null && backOrigin != '') {

                                    window.location.assign(`https://${backOrigin}/home`)
                                }
                                else if (this.$custConfig.companyPortalUrl != null && this.$custConfig.companyPortalUrl != undefined) {
                                    window.location.assign(`${this.$custConfig.companyPortalUrl}/logoutRedirect/${companyUrl}`)
                                } else {
                                    window.location.href = "/login";
                                }
                            }
                            else {
                                window.location.href = "/login";
                            }


                            this.$toast.success(this.$t('Toaster.SessionLogout'));
                        }, 500);
                    });
                    reveal(() => {
                        this.data = "";
                    });
                } catch (ex) {
                    console.log("messagessssssssssss", ex.Message)
                }


            },
            checkCurrentRoute(item) {
              
                if (item.moduleCode == this.$router.currentRoute.value.meta.moduleCode) {
                    return true;
                }
                else {
                    return false;
                }
            },
            async GetModuleList() {
                this.isLoading = true;
                try {
                    const response = await userAuthService.GetModuleList(
                        localStorage.getItem("userId"),
                        "00Test"
                    );
                    const modules = Array.isArray(response?.data) ? response.data : [];
                    this.moduleList = await applyCoOwnerMenuPolicyToSidebarTree(modules);
                } catch (ex) {
                    this.moduleList = [];
                    console.log("GetModuleList", ex);
                } finally {
                    this.isLoading = false;
                }
            },
            checkParentRoute(modulCode) {
               
                if (modulCode != null) {
                    //modulCode.replace(/\s/g, '');
                    var parentModuleCode = this.moduleList.filter(itm => itm.moduleCode === modulCode);
                    if (parentModuleCode[0].subModules != null) {
                        var childModuleCode = parentModuleCode[0].subModules.filter(itm => itm.moduleCode === this.$router.currentRoute.value.meta.moduleCode);
                        if (childModuleCode.length > 0) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else if (parentModuleCode[0].subModules == null) {
                        if (modulCode == this.$router.currentRoute.value.meta.moduleCode) {
                            return true;
                        }
                    }
                    return false;
                }
            },

            ForSrceenChange() {
                syncSidebarShellState();
            },
            async redirectToPath(path) {
                if (path == 'home') {
                    window.location.assign(`${this.$custConfig.companyPortalUrl}/${localStorage.getItem('companyUrl')}/Home`)
                    return
                }
                this.ForSrceenChange();
                if (path == null || path === '') {
                    return
                }
                const raw = typeof path === 'string' ? path.trim() : path
                const normalizedPath = typeof raw === 'string' && raw !== '' && !raw.startsWith('/') && !raw.startsWith('http://') && !raw.startsWith('https://')
                    ? `/${raw}`
                    : raw;

                if (isManageAssetsListRoute(normalizedPath)) {
                    try {
                        const targetPath = await resolveManageAssetsNavigationPath();
                        this.$router.push(targetPath);
                        return;
                    } catch (error) {
                        console.warn('Manage assets menu redirect failed', error);
                    }
                }

                this.$router.push(normalizedPath);
            },
           
            GetHeaderData() {

                UserService.getHeaderData(localStorage.getItem("userId"), '00Test').then(res => {
                    this.headerData = res.data;
                    this.imageLink = res.data.profilePic;

                })
            },
            async logout() {
                try {
                    const IPAddress = await UserService.GetIPAddress();
                    const { reveal, onConfirm } = createConfirmDialog(SimpleDialog, {
                        question: `Are you sure you want to log out?`,
                        header: `Logout`,
                        cancel: `Cancel`,
                        confirm: `Log Out`,
                    });

                    onConfirm(() => {
                        this.isLoading = true;
                        if (document.getElementById('sidebar') != null) {
                            document.getElementById('sidebar').setAttribute("class", "sidebar js-sidebar collapsed");
                            if (document.getElementById('main_full') != null) {
                                document.getElementById('main_full').setAttribute("class", "main full-section-cc");
                            }
                        }

                        setTimeout(() => {
                            UserService.LogoutHistory(localStorage.getItem('userId'), IPAddress).then(res => {

                            })
                            let userType = JSON.parse(localStorage.getItem('userinfo')).data.userType;
                            let companyDomainName = JSON.parse(localStorage.getItem('userinfo')).data.companyDomainName;
                            let companyUrl = localStorage.getItem('companyUrl')
                            localStorage.clear();
                            //if ((userType == ('usertype03') || userType == ('usertype05') || userType == ('usertype07') ||  userType == ('usertype10') ||  userType == ('usertype09') || userType == ('usertype08') || userType == ('usertype12') ) && this.$filters.IsNull(companyUrl, true, null) != null) {
                            if ((userType != ('usertype01') || userType != ('usertype02') || userType != ('usertype04') || userType != ('usertype06')) && this.$filters.IsNull(companyUrl, true, null) != null) {
                                if (this.$filters.IsNull(companyDomainName, true, null) != null) {
                                    window.location.assign(`${companyDomainName}/logoutRedirect/${companyUrl}`)
                                }
                                else if (this.$custConfig.companyPortalUrl != null && this.$custConfig.companyPortalUrl != undefined) {
                                    window.location.assign(`${this.$custConfig.companyPortalUrl}/logoutRedirect/${companyUrl}`)
                                } else {
                                    window.location.href = "/login";
                                }
                            }
                            else {
                                window.location.href = "/login";
                            }
                            this.$toast.success(`Your session has been successfully logged out.`);
                        }, 500);
                    });
                    reveal(() => {
                        this.data = "";
                    });
                } catch (ex) {
                    console.log("messagessssssssssss", ex.Message)
                }


            },

            toggleSlider() {
                var headerElement = document.getElementById('top-page-header');
                headerElement.classList.toggle("close_icon");
                var sideElement = document.getElementById('nav-page-sidebar');
                sideElement.classList.toggle("close_icon");


            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
